var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alarm-modal-wrapper"},[_c('h3',[_vm._v("Alarm Modal")]),_vm._v(" "),_c('div',{staticClass:"alarm"},[_vm._v(" "+_vm._s(JSON.stringify(_vm.alarm))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }